import * as actions from 'actions/pincodeActions';
import { getObject } from 'utils/localStorage';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { get, isEmpty } from 'lodash';
export const INITIAL_STATE = {
    localPincodes: getObject('pincodes') || [],
    suggestions: [],
    regionFilters: {},
    invalid: false,
    state: null,
    error: null,
    asyncStatus: INIT
};
export default function pincodeReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.PINCODE_REQUEST.GET_PINCODE_SUCCESS:
            let pincodeSuggestions = get(action, 'data', []);
            pincodeSuggestions = (pincodeSuggestions || []).map(item => {
                return Object.assign(Object.assign({}, item), { pincode: item.pincode.toString() });
            });
            return Object.assign({}, state, {
                suggestions: pincodeSuggestions || [],
                asyncStatus: SUCCESS
            });
        case actions.PINCODE_REQUEST.GET_PINCODE_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        case actions.PINCODE_REQUEST.GET_LOCAL_PINCODES:
            const localPincodes = getObject('pincodes') || [];
            return Object.assign({}, state, {
                localPincodes
            });
        case actions.PINCODE_REQUEST.PINCODE_VALID:
            return Object.assign({}, state, {
                valid: get(action, ['invalid'])
            });
        case actions.PINCODE_REQUEST.GET_PINCODE_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING,
                focus: false
            });
        case actions.PINCODE_DETAIL.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING,
                focus: false
            });
        case actions.PINCODE_DETAIL.SUCCESS:
            return Object.assign({}, state, {
                state: action.state ? action.state : state.state,
                city: action.city ? action.city : state.city,
                regionFilters: !isEmpty(action.regionFilters) ? action.regionFilters : state.regionFilters,
                error: null,
                asyncStatus: SUCCESS
            });
        case actions.PINCODE_DETAIL.ERROR:
            return Object.assign({}, state, {
                error: action.error,
                asyncStatus: ERROR
            });
        case actions.PINCODE_REQUEST.FOCUS_PINCODE_INPUT:
            return Object.assign({}, state, { pincodeFocus: true });
        case actions.PINCODE_SERVICEABILTY.REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING,
                focus: false
            });
        case actions.PINCODE_SERVICEABILTY.SUCCESS:
            return Object.assign({}, state, {
                marketplace: action.marketplace,
                serviceability: action.serviceability,
                pincode: action.pincode,
                message: action.message,
                error: null,
                asyncStatus: SUCCESS,
                errorMessage: ''
            });
        case actions.PINCODE_SERVICEABILTY.ERROR:
            return Object.assign({}, state, {
                errorMessage: action.errorMessage,
                pincode: action.pincode,
                marketplace: action.marketplace,
                asyncStatus: ERROR
            });
        default:
            return state;
    }
}
